import React, { useEffect, useState } from "react";
import Info from "../../../../assets/info.png";
import Refresh from "../../../../assets/Refresh_icon.svg";
import crossIcon from "../../../../assets/crossIcon.svg";
import Funnel from "../../../../assets/funnel.svg";
import {
  API_FILTER_LIST,
  APPLICABLE_ROLE,
  PENDING_HEADER_LIST,
} from "../../constant";
import MobileFilterWithDatePicker from "../../../common/Modules/MobileFilterWithDatePicker";
import Popover from "react-popover";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { USER_ROLE } from "../../../../Util/constants";

const OnlinePendingLogsHeader = ({
  onDrawerClose,
  handleRefreshedData,
  applyParams,
}) => {
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const [open, setOpen] = useState(false);
  const [doctorFilterList, setDoctorFilterList] = useState([]);
  const [actionFilterList, setActionFilterList] = useState([]);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const toggleRefresh = () => {
    handleRefreshedData();
  };

  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const [headerData, setHeaderData] = useState([...PENDING_HEADER_LIST]);
  const [selected_header_item, setSelectedHeaderItem] = useState(null);

  useEffect(() => {
    setShowMobileFilter(showMobileFilter);
    if (showMobileFilter) {
      headerData.forEach((hl) => {
        if (hl.title === "DOCTOR NAME") {
          hl.applicable_roles = [
            USER_ROLE.DOCTOR_ADMIN,
            USER_ROLE.RESOURCE_ADMIN,
            APPLICABLE_ROLE.STAFF,
          ];
        }
      });
      let headerList = headerData.filter(
        (li) =>
          li?.applicable_roles?.indexOf(userType) !== -1 ||
          li?.applicable_roles?.indexOf(doctorRole) !== -1
      );
      let list = [];
      headerList.map((menu) => menu.filter_icon && list.push(menu));
      list.forEach((li, ind) => {
        li.show_filter = false;
        if (ind === list.length - 1) {
          li.show_filter = true;
          handleMobileSelectedItem(li);
        }
      });
      setHeaderData([...list]);
    }
  }, [showMobileFilter]);

  const openMobileMenuList = (val) => {
    headerData.forEach((dh) => {
      dh.show_filter = false;
    });
    let index = headerData.findIndex((list) => list.id === val.id);
    headerData[index].show_filter = true;
    if (val?.title === "DOCTOR NAME") {
      setDoctorFilterList(headerData[index].menuData);
    }
    if (val?.title === "STATUS") {
      setActionFilterList(headerData[index].menuData);
    }
    setHeaderData([...headerData]);
    setSelectedHeaderItem(val);
  };

  const handleMobileSelectedItem = (val) => {
    setSelectedHeaderItem(val);
  };

  const handleFilterSearch = (value) => {
    let index = headerData.findIndex(
      (list) => list.title === selected_header_item.title
    );
    if (headerData[index].title === "DOCTOR NAME") {
      const filterData = doctorFilterList.filter((data) =>
        data?.name?.toLowerCase().includes(value?.toLowerCase())
      );
      headerData[index].menuData = filterData;
      setHeaderData([...headerData]);
    }
    if (headerData[index].title === "STATUS") {
      const filteredData = actionFilterList.filter(
        (doc) =>
          doc?.value?.toLowerCase()?.includes(value?.toLowerCase()) ||
          doc?.name?.toLowerCase()?.includes(value?.toLowerCase())
      );
      headerData[index].menuData = filteredData;
      setHeaderData([...headerData]);
    }
  };

  const handleResetAllFilter = () => {
    let index = headerData?.findIndex(
      (data) => data?.mobileFilterTitle === "DOCTOR NAME"
    );
    let allDoctorIndex = headerData[index]?.menuData?.findIndex(
      (doctor) => doctor?.value === "all"
    );
    let defaultPayload = {
      page_no: 1,
      rows_per_page: 10,
      ...((userType === APPLICABLE_ROLE.STAFF ||
        doctorRole === USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN) && {
        doctor_id: headerData[index]?.menuData[allDoctorIndex]?.doctor_id,
      }),
      status_filter: "",
    };
    applyParams(defaultPayload);
    handleCloseMobFilter();
  };

  const getSelectedData = (filterName) => {
    let data = headerData;
    let index = data.findIndex(
      (filterSelectedData) => filterSelectedData?.mobileFilterTitle === filterName
    );
    let selectedData = headerData[index]?.menuData.find(
      (val) => val.selected === true
    );
    switch (filterName) {
      case "DOCTOR NAME":
        return {
          doctor_id:
            selectedData?.value === "all"
              ? selectedData?.doctor_id
              : [selectedData?.id],
        };
      case "STATUS":
        return {
          status_filter:
            selectedData?.value === "all" ? "" : selectedData?.value,
        };
      default:
        return {};
    }
  };

  const handleApplyFilter = () => {
    let obj = {};
    let allSelectedDate = {};
    let selectedValue = headerData;
    selectedValue.forEach((data) => {
      allSelectedDate = getSelectedData(data?.mobileFilterTitle);
      obj = { ...obj, ...allSelectedDate };
    });
    handleCloseMobFilter();
    applyParams({ ...obj, [API_FILTER_LIST.PAGENO]: 1 });
  };

  const selectMobileFilterOptions = (item) => {
    let val = selected_header_item;
    let index = headerData.findIndex((list) => list.id === val.id);
    let index1 = headerData[index].menuData.indexOf(item);
    headerData[index].menuData.map((data) => (data.selected = false));
    headerData[index].menuData[index1].selected = true;
    setHeaderData([...headerData]);
  };

  const handleOpenMobFilter = () => {
    let headerPendingData = [...PENDING_HEADER_LIST];
    headerPendingData.forEach((item) => {
      if (item.title === "DOCTOR NAME") {
        item.show_filter = false;
        setSelectedHeaderItem(item);
      }
    });
    setHeaderData(headerPendingData);

    setShowMobileFilter(true);
  };

  const handleCloseMobFilter = () => {
    setShowMobileFilter(false);
  };

  const getHoverTitle = () => {
    return (
      <span
        style={{
          textAlign: "center",
          font: "normal normal normal 12px/17px Rubik, sans-serif",
        }}
      >
        Any appointment for which payment
        <br /> is Pending, Successful or Failed will
        <br /> be listed here.
      </span>
    );
  };

  return (
    <div className="online-pending-log-header-container">
      <div className="online-pending-log-header">
        <div className="online-pending-log-header-title">
          <div className="online-pending-log-header-text">
            Online Appointment Logs
          </div>
          <Popover
            isOpen={open}
            preferPlace="below"
            place={null}
            body={getHoverTitle()}
          >
            <img
              src={Info}
              alt=""
              style={{ height: "17px", cursor: "pointer" }}
              onMouseOver={handleTooltipOpen}
              onMouseOut={handleTooltipClose}
            />
          </Popover>
        </div>
        <div className="online-pending-log-header-icons">
          <img
            src={Refresh}
            alt="Refresh"
            onClick={toggleRefresh}
            className="online-pending-log-header-icons-refresh"
          />
          <img
            onClick={onDrawerClose}
            src={crossIcon}
            alt="X"
            className="online-pending-log-header-icons-close"
          />
        </div>
      </div>
      <div className="online-pending-log-header-note">
        <b>NOTE: </b>You can change the mode of payments to “By Cash” by
        selecting the edit option below in the case the patient is unable to pay
        online
      </div>
      {window.innerWidth < 768 && (
        <div className="text-right cursor-pointer">
          <img
            src={Funnel}
            alt="filters"
            style={{
              marginRight: 18,
              height: window.innerHeight < 444 ? "10px" : "25px",
            }}
            onClick={handleOpenMobFilter}
          />
        </div>
      )}

      {showMobileFilter && (
        <MobileFilterWithDatePicker
          showMobileFilter={showMobileFilter}
          menuList={headerData}
          selectedMenu={selected_header_item}
          handleClose={handleCloseMobFilter}
          openMobileMenuList={openMobileMenuList}
          handleMobileSelectedItem={handleMobileSelectedItem}
          selectMobileFilterOptions={selectMobileFilterOptions}
          handleApplyFilter={handleApplyFilter}
          handleResetAllFilter={handleResetAllFilter}
          handleFilterSearch={handleFilterSearch}
          placeholderForSearch={`Search ${selected_header_item?.title === "DOCTOR NAME" ? "for Doctor" : ""
            }`}
        />
      )}
    </div>
  );
};

export default OnlinePendingLogsHeader;
